<app-custom-modal customTitle="Cobro en efectivo" maxWidth="md" [hideFooter]="true" (closeFunction)="closeFunction.emit()">
  <div class="flex flex-col gap-3">

    <div class="grid grid-cols-2 gap-2">
      <div class="rounded-xl bg-slate-50 border border-slate-200 px-3 py-2">
        <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">A cobrar</p>
        <p class="text-2xl font-black text-slate-800">{{ format(due()) }} €</p>
      </div>
      <div class="rounded-xl bg-blue-50 border border-blue-200 px-3 py-2">
        <p class="text-[10px] font-bold text-blue-400 uppercase tracking-widest">Entregado</p>
        <p class="text-2xl font-black text-blue-700">{{ entered() || '—' }}@if(entered()){ €}</p>
      </div>
    </div>

    @let c = change();
    <div class="rounded-xl px-3 py-3 text-center border"
      [class]="c === null ? 'bg-slate-50 border-slate-200' : c >= 0 ? 'bg-emerald-50 border-emerald-200' : 'bg-red-50 border-red-200'">
      <p class="text-[10px] font-bold uppercase tracking-widest"
        [class]="c === null ? 'text-slate-400' : c >= 0 ? 'text-emerald-600' : 'text-red-500'">
        {{ c !== null && c < 0 ? 'Falta' : 'Cambio' }}
      </p>
      <p class="text-4xl font-black tracking-tighter"
        [class]="c === null ? 'text-slate-300' : c >= 0 ? 'text-emerald-700' : 'text-red-600'">
        {{ c === null ? '—' : format(c < 0 ? -c : c) + ' €' }}
      </p>
    </div>

    <div class="grid grid-cols-3 sm:grid-cols-6 gap-2">
      <button type="button" (click)="setExact()"
        class="h-11 rounded-lg bg-slate-800 text-white font-bold text-xs uppercase tracking-widest hover:bg-slate-700 active:scale-95 transition-all">
        Exacto
      </button>
      @for (bill of quickBills; track bill) {
      <button type="button" (click)="addBill(bill)"
        class="h-11 rounded-lg bg-emerald-100 text-emerald-800 border border-emerald-200 font-black text-sm hover:bg-emerald-200 active:scale-95 transition-all">
        +{{ bill }} €
      </button>
      }
    </div>

    <div class="grid grid-cols-3 gap-2">
      @for (key of keys; track key) {
      <button type="button" (click)="pressKey(key)"
        class="h-12 rounded-lg bg-white border border-slate-200 text-xl font-bold text-slate-700 hover:bg-slate-50 active:scale-95 transition-all">
        {{ key }}
      </button>
      }
    </div>

    <div class="flex gap-2">
      <button type="button" (click)="clear()"
        class="flex-1 h-12 rounded-xl bg-slate-100 text-slate-600 font-bold text-xs uppercase tracking-widest hover:bg-slate-200 transition-all">
        Borrar
      </button>
      <button type="button" (click)="confirm()" [disabled]="!canConfirm()"
        class="flex-2 h-12 rounded-xl bg-blue-600 text-white font-black text-xs uppercase tracking-widest hover:bg-blue-500 active:scale-95 transition-all disabled:opacity-30">
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</app-custom-modal>
